// import '../../static/js/zoomcharts.js'
// import store from "../store/index.js";
import {nodeStyle,linkStyle} from '../common/chartOptions.js'
// import {repeat} from '../common/methods.js'
// import {nodefunction,linkfunction,nodeContent,linkContent} from '../common/chartTipContent.js'
import {nodefunction,linkfunction} from '../common/chartTipContent.js'

const ZoomChart = {}

ZoomChart.install = function(Vue){
	const makeMap = {
		renderChart:function(data,initialNodeId){
			// if(!data) data = store.state.netResult
			// data = data || store.state.netResult
			// initialNodeId = initialNodeId || store.state.initialNodes
			// if(!initialNodeId) initialNodeId = store.state.initialNodes
			const options = {
				container:'chartRelation',
				// area:{
				// 	maxWidth:1920,
				// 	maxHeight:1080,
				// },
				interaction: {
		            resizing: {
		              enabled: true
		            },
		            selection:{
		            	lockNodesOnMove:true,
		            	// tolerance:3
		            },
		            zooming: {
		              initialAutoZoom:true,
		              doubleClickZoom:3,
		              zoomExtent: [0.1, 2],
		            },
		        },

		        navigation: {
		            // 谁为目标节点,分多节和单节点
		            initialNodes: initialNodeId,
		            mode: "focusnodes" ,
		            // initialNodes: null,
		            // mode: "showall" ,
		            // 默认展开的层数
		            focusNodeExpansionRadius: 60,
		            focusNodeTailExpansionRadius: 0.3,
		            numberOfFocusNodes: 600,//如果这个过少会影响initialNodes，在多节点中
		            // autoUnfocus:false,
		            // autoZoomOnFocus:true
		            expandOnClick: true

		        },

		        data: {
		            preloaded:data
		        },

		        layout: {
		        	// aspectRatio:true,
		            mode: "dynamic",//radial hierarchy dynamic
		            // incrementalLayoutMaxTime:1,
		            // initialLayoutMaxTime:10,
		            // layoutFreezeMinTimeout:5,
		            // globalLayoutOnChanges:false,//这个不能随便加，尤其是利用nodefilter的时候，不然会进行节点拉伸
		            nodeSpacing:60,
		            // twoRingRadialLayout:true,//在radial模式中，隔一个差一点
		            // groupSpacing:10,
		            rowSpacing:20,
		            layoutFreezeTimeout:550
		        },

		        style:{
		        	// nodeAutoScaling:"logaritmic",
		            // nodeRadiusExtent:[100,150],
		            // linkAutoScaling:'linear',
		            nodeLabelScaleBase:10,
		            node:{
		              display:"image",
		              imageCropping: true
		            },
		            nodeDetailMinSize:0,
		            linkDecorationMinSize:0.4,//箭头的大小
		            linkDecorationScale:5,//箭头比例
		            nodeDetailMinZoom:0,
		            selection:{
		              fillColor:"#9aabeb",//颜色//022ccc
		              sizeConstant:3 ,
		              shadowColor: "transparent"
		            },
		            // nodeHovered:{
		            //   shadowColor:"#3f51b5"
		            // },
		            // nodeSelected:{
		            //   shadowColor:"#3f51b5",
		            //   shadowBlur:20
		            // },
		            // linkHovered:{
		            //   shadowColor:"#666"
		            // },
		            // linkSelected:{
		            //   shadowColor:"#666"
		            // },
		            nodeStyleFunction:nodeStyle,//节点样式
		            linkStyleFunction:linkStyle,//节点之间连线的样式
		            nodeLabel:{
						textStyle:{
							fillColor: '#444',
							font: "12px 微软雅黑"
						},
						backgroundStyle:{
							fillColor:"transparent"
						},
						borderRadius: 0,
						maxWidth: 200,
						align:"center",
						aspectRatio:4,
						padding:4,
						scaleWithSize:false,
						scaleWithZoom:true //字的大小
					},
					nodeRadiusExtent:[0,20],
					linkLengthExtent:[0,10],
		            link: {
						toDecoration:"arrow",//箭头
						fromDecoration:"",//箭头
						strength:100
		            },
		            linkLabel:{
						padding: 2,
						textStyle:{
							font:"12px 宋体",
							fillColor: "#666"
						},
						backgroundStyle:{
							fillColor:"#fff",
							lineColor:"#fff"
						}
		            }
		        },

		        info:{
		        	enabled: true,
		        	nodeContentsFunction:nodefunction,//移入节点 显示样式
		        	linkContentsFunction:linkfunction//移入节点之间连线 显示样式
		        },

		        nodeMenu:{
		            buttons:["hide","expand"]   //dynaminc
		        },

		        localization:{
		            menu:{
		              hide:"隐藏",
		              collapse:"合并",
		              expand:"展开隐藏节点"
		            },
		            toolbar:{
		              fitTitle:"适合屏幕",
		              rearrangeTitle:"重新排列元素",
		              unfreezeTitle:"解锁全部",
		              freezeTitle:"全部锁定",
		              backTitle:"撤销上一步操作",
		              fullscreenTitle: "切换全屏模式",
		            }
		        },

		        linkMenu:{
		            enabled:false
		        },
				advanced:{
					pointer:{
						scrollIntoView:false
					}
				},

				events:{
		            // onClick:function(event){
		            // 	if(store.state.nl_Status) return
		            // 	if(event.clickNode){
		            // 		chart.getNode(event.clickNode.id)
		            // 		addToLog(nodeContent(event.clickNode.data))
		            // 	}else if(event.clickLink){
		            // 		addToLog(linkContent(event.clickLink.data,event.clickLink))
		            // 	}else{
		            // 		addToLog("<p class='tip_content'>各个节点和关系的详情面板</br>请点击需要查看的节点或关系</p>")
		            // 	}
		            // 	event.preventDefault();
		            // },
		            // onDoubleClick:function(event){
		            // 	if(!event.clickNode){
		            // 		event.preventDefault();
            		// 		return;
		            // 	}
		            // 	if(store.state.routeType == "risk"){
		            // 		if(event.clickNode.data.type == 0){
		            // 			event.preventDefault();
            		// 			return
		            // 		}else if(event.clickNode){
		            // 			if(event.clickNode.data.innode||event.clickNode.data.type == 3){
		            // 				event.preventDefault();
		            // 				return
		            // 			}else{
		            // 				var riskArray = []
		            // 				event.chart.replaceData(store.state.netResult)
		            // 				// 如果没有zsid
		            // 				// 如果没有queryAttrId 说明是查看我的图谱中的双击事件
		            // 				if(!store.state.queryAttrId){
		            // 					var relationRisk = ["invest", "manager", "sametel", "samedom"]
		            // 				}else{
		            // 					var relationRisk = store.state.queryAttrId.split(";")
		            // 				}
		            // 				var sign = ["tomanynodes"]
		            // 				if(event.clickNode.data.properties.zsid){
		            // 					riskArray.push(store.state.innode_zsid,event.clickNode.data.properties.zsid)
		            // 					sign.push(store.state.innode_zsid)
		            // 				}else{
					//
		            // 					if(event.clickNode.data.type == 1){
		            // 						riskArray.push(store.state.queryName,event.clickNode.label)
		            // 					}else if(event.clickNode.data.type == 2){
		            // 						riskArray.push(store.state.queryName,event.clickNode.data.properties.palgorithmid)
		            // 					}
					//
		            // 					sign.push(store.state.queryName)
		            // 				}
		            // 				var riskConditions ={
		            // 					"entmark":riskArray.join(","),
					// 	                "layer":store.state.queryModel,
					// 	                "relations":relationRisk,
					// 	                "sign":sign//["tomanynodes"]
		            // 				}
		            // 				var riskJson = JSON.stringify(riskConditions);
		            // 				store.state.loadding = true
		            // 				axios.post(api.risk_relation,riskJson).then(res=>{
		            // 					store.state.loadding = false
		            // 					let data = res.data
		            // 					if(data.result.nodes.length == 0||data.result.links.length == 0){
		            // 						alert("无数据")
		            // 						return;
		            // 					}
		            // 					// ES6扩展运算符实现数组的深拷贝
					// 					let [ ...resNodesArray ] = data.result.nodes
					// 					let [ ...resLinksArray ] = data.result.links
					//
					// 					// 获得所有点击过的点的id和风险系数
					// 					for(let i=0;i<resNodesArray.length;i++){
					// 	                    if(resNodesArray[i].id == event.clickNode.id){
					// 	                      	var id = resNodesArray[i].id,pathLength = resNodesArray[i].properties.pathLength
					// 	                      	store.state.doubleMap.push({
					//                                       		id:id,
					// 	                                    	pathLength:pathLength
					// 	                                    })
					// 	                    }
					// 	                }
					//
					// 	                // 先判断是否有多余节点
					// 	                for(let i=0;i<store.state.netResult.nodes.length;i++){
					// 	                    for(let j=0;j<data.result.nodes.length;j++){
					// 							if(store.state.netResult.nodes[i].id == data.result.nodes[j].id){
					// 								data.result.nodes.splice(j,1)
					// 								j--;
					// 							}
					// 						}
					// 					}
					//
					// 					// 将返回的link的id与原有的link进行合并 不能用splice 因为下面还有对比 不能改变原有数组
					// 					for(let i = 0;i<store.state.netResult.links.length;i++){
					// 						for(let j = 0 ; j<data.result.links.length;j++){
					// 							if(store.state.netResult.links[i].from == data.result.links[j].from&&store.state.netResult.links[i].to == data.result.links[j].to){
					// 								data.result.links.splice(j,1)
					// 								j--;
					// 							}
					// 						}
					// 					}
					//
					// 					// 合并后的新的node和link的组合
					// 					let newNet = {}
					// 					newNet.nodes = store.state.netResult.nodes.concat(data.result.nodes)
					// 					newNet.links = store.state.netResult.links.concat(data.result.links)
					//
					// 					// 需要改变颜色的数组
					// 					let risklink = []
					// 					for(let i = 0;i<newNet.links.length;i++){
					// 						newNet.links[i]["color"] = false
					// 						for(let j = 0;j<resLinksArray.length;j++){
					// 							if(newNet.links[i].id == resLinksArray[j].id){
					// 								risklink.push(newNet.links[i])
					// 							}
					// 						}
					// 					}
					// 					// 改变颜色
					// 					for(let i = 0 ;i<risklink.length;i++){
					// 	                    risklink[i]["color"] = true
					// 	                }
					// 	                // node属性合并
					// 					for(let i =0 ;i<newNet.nodes.length ; i++){
					// 						for(let j =0;j<resNodesArray.length;j++){
					// 							if((newNet.nodes[i].id == resNodesArray[j].id)&&newNet.nodes[i].innode == false){
					//
					// 								newNet.nodes[i].properties = $.extend( true, newNet.nodes[i].properties, resNodesArray[j].properties );
					// 							}
					// 						}
					// 					}
					//
					// 					let linksAfterMerge = [];
					// 					// 合并线
					// 					$.each(newNet.links,function(i,value){
					// 						var link = value;
					// 						if(!repeat(linksAfterMerge,link)){
					// 							linksAfterMerge.push(link);
					// 						}
					// 					});
					// 					newNet.links = linksAfterMerge;
					// 					// 视图更新
					// 					event.chart.replaceData(newNet)
		            // 				}).catch(err=>{
		            // 					console.log(err)
		            // 				})
		            // 			}
		            // 		}
		            // 	}
		            // 	event.preventDefault();
		            // }

		            // onDataUpdated:_this.onDataUpdated
		        },

		        // filters: {
		        //     nodeFilter: nodeFilter
		        // }
			}

			// function addToLog(text){
			// 	$('#nlContent').empty()
			// 	$('#nlContent').html(text)
			// }

			// 不同的展现方式
			// if(store.state.routeType == 'contrlway'||store.state.routeType == '控制路径'){
			// 	options.layout={
			// 		mode:"hierarchy",//环形结构
			// 		rowSpacing:230,
			// 		nodeSpacing: 40
			// 	}
			// 	options.interaction.selection.lockNodesOnMove = true
			// }


			if(data.nodes.length<60){
				options.layout.nodeSpacing=160;
				// if(store.state.routeType == 'contrlway'){
					// options.layout.nodeSpacing=80
					// options.layout.rowSpacing=230
				// }
			}else if(data.nodes.length>1000){
				// if(store.state.routeType == 'contrlway'){
					// options.layout.nodeSpacing=80
					// options.layout.rowSpacing=4000
				// }
				// else{
					options.navigation.focusNodeExpansionRadius = 1
				// }

			}

			//5层机制
			// console.log(store.state.queryModel)
			// if(store.state.queryModel == 5){
			// 	options.navigation.focusNodeExpansionRadius = 1
			// }

			const chart = new NetChart(options)

			return chart
		},

	}
	Vue.prototype.makeMap = makeMap
}

export default ZoomChart



// WEBPACK FOOTER //
// ./src/plugins/ZoomChart.js